var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 138,
    viewBox: "0 0 250 138",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0434393 27.8164H61.1962V137.605H95.7494V27.8164H156.902V0H0V27.8164H0.0434393Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.078 42.8984V137.952H133.954V59.4579H115.265V49.8525L151.078 42.8984Z",
    fill: "#AEE4E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250 73.1469V56.457C250 48.8944 243.828 42.7227 236.222 42.7227H177.329C169.767 42.7227 163.551 48.8944 163.551 56.457V70.4522L178.59 74.1031V57.7174H234.918V72.5819L167.811 111.916C165.203 113.437 163.551 116.262 163.551 119.261V130.649C163.551 134.387 166.594 137.429 170.332 137.429H234.309C242.915 137.429 249.956 130.431 249.956 121.782V112.351L234.918 107.7V122.347H179.676L243.437 84.9689C247.479 82.5784 250 78.0582 250 73.1469Z",
    fill: "#AEE4E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e3610f445e3a53e55be9e736ff2e6b0.svg";
export { ForwardRef as ReactComponent };